class DynamicVariantVideo extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('resize', () => {
			this.isMobile = window.matchMedia('(max-width: 999px)').matches;
		});
	}

	connectedCallback() {
		this.isMobile = window.matchMedia('(max-width: 999px)').matches;
		const desktopVideo = this.querySelector('.product-video--desktop');
		const mobileVideo = this.querySelector('.product-video--mobile');
		this.video = this.querySelector('video');
		if (this.isMobile && mobileVideo) {
			this.video = mobileVideo;
		}

		if (this.isMobile) {
			desktopVideo?.remove();
		} else {
			mobileVideo?.remove();
		}



		document.addEventListener('variant:change', (event) => {
			const variant = event.detail.variant;
			const variantVideo = window.productSection.videoSources.find((video) => video.variantId === variant.id);

			if (!variantVideo) {
				this.removeVideoElement();
				return;
			}

			if (!this.video) {
				this.insertVideoElement();
			}

			if (this.isMobile && variantVideo.mobileVideo) {
				this.updateVideoSource(variantVideo.mobileVideo.sources, variantVideo.mobileVideo.imageUrl);
				return;
			}

			if (variantVideo.desktopVideo) {
				this.updateVideoSource(variantVideo.desktopVideo.sources, variantVideo.imageUrl);
			} else {
				this.removeVideoElement();
			}
		});
	}

	updateVideoSource(sources, posterUrl) {
		const highestQualitySource = sources.reduce((prev, current) => {
			return prev.height > current.height || current.format !== 'mp4' ? prev : current;
		});
		this.video.src = highestQualitySource.url;
		this.video.poster = posterUrl;
	}

	insertVideoElement() {
		this.video = document.createElement('video');
		this.video.classList.add('object-cover');
		this.video.autoplay = this.autoplay;
		this.video.controls = false;
		this.video.playsInline = true;
		this.video.muted = this.autoplay;
		this.video.loop = this.getAttribute('loop') === 'true';
		this.video.preload = 'metadata';
		this.appendChild(this.video);
	}

	removeVideoElement() {
		if (this.video) {
			this.video.remove();
			this.video = null;
		}
	}

	get autoplay() {
		return this.getAttribute('autoplay') === 'true';
	}
}

if (!window.customElements.get('dynamic-variant-video')) {
	window.customElements.define('dynamic-variant-video', DynamicVariantVideo);
}
